import { Component, OnInit, Input, AfterContentInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'trial-over',
  templateUrl: './trial-over.component.html',
  styleUrls: ['./trial-over.component.sass']
})
export class TrialOverComponent implements OnInit, AfterContentInit {

  @Input() businessName: string;
  @Input() businessPhoneNumber: string;
  @Input() businessZipCode: string;
  @Input() userEmail: string;
  @Input() userFullName: string;
  @Input() trialOverForm: string;

  sanitizedTrailOverForm : SafeResourceUrl = '';

  constructor(
    private sanitizer:DomSanitizer
  ) {

   }

  ngOnInit() {
    console.log(this.businessPhoneNumber)
  }
  
  ngAfterContentInit(){
    
    this.sanitizedTrailOverForm = this.sanitizer.bypassSecurityTrustResourceUrl(this.trialOverForm + 
      'cov[business_name]={businessName}&cov[business_phone]={businessPhoneNumber}&cov[business_zip]={businessZipCode}&cov[fullname]={userFullName}&cov[email]={userEmail}&cov[trial_days]=0'
      .replace('{businessName}',this.businessName ? this.businessName : '')
      .replace('{businessPhoneNumber}',this.businessPhoneNumber ? this.businessPhoneNumber : '')
      .replace('{businessZipCode}', this.businessZipCode ? this.businessZipCode : '')
      .replace('{userFullName}', this.userFullName ? this.userFullName : '')
      .replace('{userEmail}', this.userEmail ? this.userEmail : '')
    )
  }
}
